// src/pages/PackReaderSkills.jsx
//
// Skills-workshop student reader -- a THIN WRAPPER over the shared PackReaderGrouped.
// Supplies the skills grouping: a tiered nav split by content type ("Techniques" /
// "Thematic Vocabulary" / "Past Papers", via buildNavSections), each tier grouped by
// content.blocks.unit (author/first-seen order; un-unit'd sections fold into the
// tier's own label). Each section renders by its kind (technique -> TechniqueSection,
// vocabulary -> VocabularySection, analysis -> AnalysisSection), with flashcards ON.
// Quiz + essay practice + entitlement gating + chrome all come from the shared reader.
import React from 'react';
import PackReaderGrouped from './PackReaderGrouped.jsx';
import { selectSkillsSections, buildSkillsNavSections, skillsNavGroupKey } from './skillsSections.js';
import TechniqueSection from './TechniqueSection.jsx';
import AnalysisSection from './AnalysisSection.jsx';
import VocabularySection from './VocabularySection.jsx';

// Render one skills section by its sectionKind. key={item.id}: the shared reader
// mounts consecutive same-kind sections as the same element type at a fixed
// position, so without a key React would preserve per-section state (e.g. a
// worked example's revealed model) across section switches.
function renderSkillsSection(item, group, done, lessonOptions) {
    const kind = item && item.content && item.content.sectionKind;
    if (kind === 'analysis') {
        return <AnalysisSection key={item.id} content={item.content} done={done} lessonOptions={lessonOptions} />;
    }
    if (kind === 'vocabulary') {
        return <VocabularySection key={item.id} content={item.content} done={done} lessonOptions={lessonOptions} />;
    }
    return <TechniqueSection key={item.id} content={item.content} done={done} lessonOptions={lessonOptions} />;
}

const SKILLS_CONFIG = {
    headerLabel: 'Skills Workshop',
    itemType: 'lit_section',
    enableFlashcards: true,
    selectSections: selectSkillsSections,
    // Two-tier nav (Techniques / Past Papers). No buildGroups: the shell only calls
    // it when buildNavSections is absent. groupKeyOf matches the kind-prefixed group
    // keys buildSkillsNavSections emits (deep-link ?item= selection).
    buildNavSections: buildSkillsNavSections,
    groupKeyOf: skillsNavGroupKey,
    subListLabel: (item) => (item.content && item.content.title) || item.id,
    renderSection: renderSkillsSection,
};

export default function PackReaderSkills() {
    return <PackReaderGrouped config={SKILLS_CONFIG} />;
}
